import { type LocationListingQuery } from 'cms/cms';
import HTMLReactParser from 'html-react-parser';
import { resolveImageReferenceToImage } from './imageResolver';
import { type ContentModelReference } from 'cms/cms-types';
import { type LocationCardProps } from '4-sections/FilteredListings/MapAndListing/LocationCard';

export type LocationPage = NonNullable<LocationListingQuery['LocationPage']>;
export type LocationPageItems = NonNullable<LocationPage['items']>;

export interface LocationCardResolverSettings {
    emailLabel: string;
    telLabel: string;
}

export interface GenerateDescriptionProps {
    Address?: string | null;
    EmailAddress?: string | null;
    PhoneNumber?: string | null;
    emailLabel?: string;
    telLabel?: string;
}

export const generateDescription = ({ Address, EmailAddress, PhoneNumber, emailLabel, telLabel }: GenerateDescriptionProps): string => {
    const telNumber = PhoneNumber ? `${telLabel ? `<span>${telLabel}:</span> ` : ''}<span>${PhoneNumber}</span><br />` : '';
    const emailAddress = EmailAddress ? `${emailLabel ? `<span>${emailLabel}:</span> ` : ''}<span>${EmailAddress}</span>` : '';
    const contact = telNumber || emailAddress ? `<p>${telNumber}${emailAddress}</p>` : '';
    return `<div class="card-description-address">${Address}</div><div class="card-description-contact">${contact}</div>`;
};


export const resolveLocationPagesToLocationCards = (items: LocationPageItems): LocationCardProps[] => {
    return items.map(item => {
        // the autogenerated produce | null for each item, need to remove the | null type
        const { Title, PreviewTitle, Address, PhoneNumber, EmailAddress, ContentLink, PreviewImage } = item as NonNullable<typeof item>;
        const imgSrcSets = [480, 767];
        const img = resolveImageReferenceToImage(PreviewImage as ContentModelReference, '?width=1280', imgSrcSets);
        const description = generateDescription({ Address, EmailAddress, PhoneNumber });

        return {
            ...(ContentLink?.Url && { link: { href: ContentLink.Url } }),
            title: PreviewTitle || Title as string,
            ...(Address && { children: HTMLReactParser(description as string) }),
            ...(img && { img }),
        };
    });
};
